<template>
  <div
    v-if="items.length"
    class="category-slider"
    :class="{'category-slider--without-container': withoutContainer}">
    <header class="category-slider__header">
      <div class="category-slider__title-wrap">
        <h3 class="category-slider__title">{{ title }}</h3>
        <a
          v-if="link"
          :href="link"
          class="category-slider__more">
          {{ computedLinkTitle }}
        </a>
      </div>
      <div class="category-slider__navigation">
        <div
          class="swiper-button-prev"
          :class="[transliterate(title) + '-prev']"
          slot="button-prev"></div>
        <div
          class="swiper-button-next"
          :class="[transliterate(title) + '-next']"
          slot="button-next"></div>
      </div>
    </header>
    <swiper
      class="swiper"
      :options="swiperOption">
      <swiper-slide
        class="swiper-item"
        v-for="(item, i) in items"
        :key="i">
        <a
          class="category-item"
          :href="item.link">
          <img
            class="category-item__img"
            :src="item.image_src"
            :alt="item.title" />
          <span class="category-item__title">{{ item.title }}</span>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { transliteration } from '../../mixins/transliteration'
import { isTouch } from '../../mixins/isTouchDevice'

export default {
  name: 'CategorySlider',
  mixins: [transliteration, isTouch],
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    linkTitle: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    withoutContainer: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  computed: {
    computedLinkTitle () {
      return this.linkTitle || this.$t('see_all')
    },
    swiperOption () {
      return {
        watchOverflow: true,
        watchSlidesVisibility: true,
        spaceBetween: 25,
        slidesPerView: 1.5,
        navigation: {
          nextEl: '.' + this.transliterate(this.title) + '-next',
          prevEl: '.' + this.transliterate(this.title) + '-prev'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          319: {
            slidesPerView: 1.2
          },
          550: {
            slidesPerView: 2.2
          },
          769: {
            slidesPerView: 3
          },
          1100: {
            slidesPerView: 4
          },
          1300: {
            slidesPerView: 5
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="sass">
@import "~swiper/css/swiper.min.css"

@import "../../styles/swiper/swiper"

.category-slider
  ::v-deep
    .swiper-wrapper
      align-items: stretch

    .swiper-item
      height: auto

.category-slider--without-container ::v-deep
  margin: 0 -15px

.category-slider__header,
.swiper-container
  padding: 0 15px

.category-slider__header
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: center
  margin-bottom: 15px

  +mmin($tablet)
    margin-bottom: 30px

.category-slider__title-wrap
  display: flex
  flex-flow: row wrap
  align-items: baseline
  justify-content: space-between
  width: 100%

  +mmin($tablet)
    width: auto
    justify-content: flex-start

.category-slider__title
  font-size: 18px
  font-weight: 500
  padding: 0
  margin: 0

  +mmin($tablet)
    font-size: 24px

.category-slider__more
  color: $main-color
  font-size: 14px
  font-weight: 400 //Rubik 300

  +mmin($tablet)
    font-size: 16px
    margin-left: 20px

  &:hover,
  &:focus,
  &:active
    color: $main-color--hover

.category-slider__navigation
  display: none
  position: relative
  width: 70px

  +mmin($tablet)
    display: block

// category item
.category-item
  display: flex
  flex-flow: column
  height: 100%
  box-sizing: border-box
  padding: 20px 40px
  border: 1px solid $nd-border-color
  border-radius: 10px

.category-item__img
  display: block
  width: 100%
  margin-bottom: 10px

.category-item__title
  display: block
  text-align: center
  color: $text-color
  font-size: 14px
  margin-top: auto
</style>
